const MAX_SAFE_INTEGER = 9007199254740991
export function withinRange(current, start = 0, stop = MAX_SAFE_INTEGER) {
  return current >= start && current <= stop
}

export function withinStops(currentTime, stops, targetStop, nrOfStops = 1) {
  const uniqueStops = stops.filter(unique)
  const targetTime = stops[targetStop]
  const prevTime = uniqueStops[uniqueStops.indexOf(targetTime) - nrOfStops]
  const nextTime = uniqueStops[uniqueStops.indexOf(targetTime) + nrOfStops]
  return withinRange(currentTime, prevTime, nextTime)
}

function unique(value, index, self) {
  return self.indexOf(value) === index
}
